(function () {
  var FORM_SELECTOR = '#la-prescription-form';
  var UPLOAD_CARD_MARKER = '.ciw-la-upload-rx-card';
  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');

  function shared() {
    return window.ciwLaManualRxEnhanceApi || null;
  }

  function isEyeglassHost() {
    return !!document.querySelector('.ciw-pdp');
  }

  function isContactLensHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function countReadyEyeSelects(container) {
    if (!container || container.classList.contains('ciw-la-manual-rx-hidden')) {
      return 0;
    }

    return container.querySelectorAll('.la-form-item select, .la-form-item .la-form-select, select').length;
  }

  function isUploadCandidate(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return false;
    }

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper) {
      return false;
    }

    return !!(
      form.querySelector('#la-prescription-file') ||
      uploadWrapper.querySelector('input[type="file"], lensadvizor-selfie')
    );
  }

  function isUploadWrapperActive(form) {
    var uploadWrapper = form && form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper || uploadWrapper.classList.contains('ciw-la-manual-rx-hidden')) {
      return false;
    }

    return isUploadCandidate(form);
  }

  function isUploadWrapperVisible(form) {
    if (!isUploadWrapperActive(form)) {
      return false;
    }

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    var style = window.getComputedStyle(uploadWrapper);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isManualPrescriptionStep(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return false;
    }

    if (form.querySelector('.ciw-la-upload-rx-card')) {
      return false;
    }

    if (isUploadWrapperActive(form)) {
      return false;
    }

    if (form.querySelector('.ciw-la-manual-rx-card--mobile:not(.ciw-la-upload-rx-card)')) {
      return true;
    }

    if (
      form.classList.contains('ciw-la-manual-rx-form--mobile') &&
      !form.classList.contains('ciw-la-upload-rx-form--mobile')
    ) {
      return true;
    }

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (uploadWrapper && uploadWrapper.classList.contains('ciw-la-manual-rx-hidden')) {
      return true;
    }

    return false;
  }

  function isUploadPrescriptionStep(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || isManualPrescriptionStep(form)) {
      return false;
    }

    if (
      form.querySelector('.ciw-la-upload-rx-card') ||
      form.classList.contains('ciw-la-upload-rx-form--mobile')
    ) {
      return true;
    }

    return isUploadWrapperActive(form);
  }

  function isUploadPath(form) {
    return isUploadPrescriptionStep(form);
  }

  function isManualEntryActive(form) {
    if (isUploadPath(form)) {
      return false;
    }

    if (
      form.classList.contains('ciw-la-manual-rx-form--mobile') &&
      form.querySelector('.ciw-la-manual-rx-card--mobile:not(.ciw-la-upload-rx-card) .ciw-la-manual-rx-section--rx')
    ) {
      return true;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');
    return countReadyEyeSelects(rightRx) >= 3 && countReadyEyeSelects(leftRx) >= 3;
  }

  function revealUploadNode(node) {
    var api = shared();
    if (!node) {
      return;
    }

    if (api && api.revealElement) {
      api.revealElement(node);
    }

    node.style.setProperty('display', 'block', 'important');
    node.style.setProperty('visibility', 'visible', 'important');
    node.style.setProperty('opacity', '1', 'important');
  }

  function getLensAdvizorPrescriptionConfig(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.options || !la.options.prescriptionConfig) {
      return null;
    }

    return la.options.prescriptionConfig;
  }

  function requireUploadPdEnabled(la) {
    var config = getLensAdvizorPrescriptionConfig(la);
    if (!config) {
      return false;
    }

    if (config.pdOnUpload === 1 || config.pdOnUpload === '1') {
      if (!config.pdOnUploadUsageType) {
        config.pdOnUploadUsageType = 'distance';
      }
      return true;
    }

    config.pdOnUpload =
      config.pdRequired &&
      config.pdRequired !== 'hidden' &&
      config.pdRequired !== false &&
      config.pdRequired !== 0
        ? config.pdRequired
        : 1;
    if (!config.pdOnUploadUsageType) {
      config.pdOnUploadUsageType = 'distance';
    }

    return true;
  }

  function ensureUploadPdConfig(la) {
    return requireUploadPdEnabled(la);
  }

  function primeUploadPdConfig(la) {
    la = la || window.LensAdvizor;
    return ensureUploadPdConfig(la);
  }

  function patchLensAdvizorUploadPd() {
    var la = window.LensAdvizor;
    if (!la || typeof la.renderUploadForm !== 'function') {
      return false;
    }

    if (la.__ciwUploadPdPatched) {
      primeUploadPdConfig(la);
      return true;
    }

    la.__ciwUploadPdPatched = true;

    var originalRenderUpload = la.renderUploadForm.bind(la);
    la.renderUploadForm = function () {
      requireUploadPdEnabled(this);
      return originalRenderUpload.apply(this, arguments);
    };

    if (typeof la.updateState === 'function') {
      var originalUpdateState = la.updateState.bind(la);
      la.updateState = function (step) {
        var stepName = typeof step === 'function' ? step.name : step && step.name;
        if (stepName && String(stepName).indexOf('renderUploadForm') >= 0) {
          requireUploadPdEnabled(this);
        }
        return originalUpdateState.apply(this, arguments);
      };
    }

    primeUploadPdConfig(la);
    return true;
  }

  var uploadPdObserver = null;

  function isUploadNodeVisible(node) {
    if (!node || node.classList.contains('ciw-la-manual-rx-hidden')) {
      return false;
    }

    var style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function uploadCardHasVisiblePd(card) {
    if (!card) {
      return false;
    }

    var pdSection = card.querySelector('.ciw-la-manual-rx-section--pd, [data-ciw-la-upload-pd-fallback="1"]');
    if (!pdSection) {
      return false;
    }

    var pdFields = pdSection.querySelector('#la-pd-fields-container');
    if (!pdFields) {
      return false;
    }

    var splits = pdFields.querySelectorAll('.ciw-la-pd-split');
    for (var i = 0; i < splits.length; i++) {
      var split = splits[i];
      if (!isUploadNodeVisible(split)) {
        continue;
      }

      if (split.querySelector('.ciw-la-rx-select__trigger, select, .la-form-select')) {
        return true;
      }
    }

    var nativeSelects = pdFields.querySelectorAll(
      '#la-pd-value, select[data-field="value"], select[name="la-pd-value"]'
    );
    for (var j = 0; j < nativeSelects.length; j++) {
      var select = nativeSelects[j];
      var formItem = select.closest('.la-form-item') || select;
      if (!formItem.classList.contains('ciw-la-manual-rx-hidden') && isUploadNodeVisible(formItem)) {
        return true;
      }
    }

    if (pdFields.classList.contains('ciw-la-manual-rx-pd-fields--dual')) {
      var dualSelects = pdFields.querySelectorAll(
        'select[data-field="right"], select[data-field="left"], select[name="la-pd-right"], select[name="la-pd-left"]'
      );
      for (var k = 0; k < dualSelects.length; k++) {
        var dualSelect = dualSelects[k];
        var dualItem = dualSelect.closest('.la-form-item');
        if (dualItem && !dualItem.classList.contains('ciw-la-manual-rx-hidden') && isUploadNodeVisible(dualItem)) {
          return true;
        }
      }
    }

    return false;
  }

  function uploadCardHasPd(card) {
    return uploadCardHasVisiblePd(card);
  }

  function isUploadEnhancementComplete(form, card) {
    if (!form || !card) {
      return false;
    }

    if (
      !(
        form.classList.contains('ciw-la-upload-rx--ready') &&
        uploadCardHasPd(card) &&
        !uploadCardMissingConfirm(form, card)
      )
    ) {
      return false;
    }

    /* After AI extract, native OD/OS containers appear — keep enhancing until the
       new Manual-Rx grid is in the upload card. */
    if (hasExtractableRxContainers(form) && !uploadCardHasRxGrid(card)) {
      return false;
    }

    return true;
  }

  function hasExtractableRxContainers(form) {
    var api = shared();
    if (!form || !api || typeof api.areRxContainersReady !== 'function') {
      return false;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');
    return !!(rightRx && leftRx && api.areRxContainersReady(rightRx, leftRx));
  }

  function uploadCardHasRxGrid(card) {
    var api = shared();
    if (api && typeof api.cardRxGridHasSelects === 'function') {
      return api.cardRxGridHasSelects(card);
    }

    return !!(
      card &&
      card.querySelector('.ciw-la-manual-rx-section--rx .ciw-la-rx-eye-block--od select') &&
      card.querySelector('.ciw-la-manual-rx-section--rx .ciw-la-rx-eye-block--os select')
    );
  }

  /* Upload-and-Extract fills LA's native OD/OS containers. Fold them into the same
     ciw-la-rx-grid used by Enter Manually so customers don't see the old layout. */
  function attachExtractedRxGrid(form, card) {
    var api = shared();
    if (!form || !card || !api) {
      return false;
    }

    if (typeof api.buildRxSection !== 'function' || typeof api.areRxContainersReady !== 'function') {
      return false;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');
    if (!rightRx || !leftRx || !api.areRxContainersReady(rightRx, leftRx)) {
      return false;
    }

    if (uploadCardHasRxGrid(card)) {
      if (typeof api.hideElement === 'function') {
        api.hideElement(rightRx);
        api.hideElement(leftRx);
      }
      placeExtractionDisclaimer(form, card);
      hideOrphanUploadPdContainers(form, card);
      return true;
    }

    var existing = card.querySelector('.ciw-la-manual-rx-section--rx');
    if (existing) {
      if (typeof api.restoreNativeRxFields === 'function') {
        api.restoreNativeRxFields(form, card);
      }
      existing.remove();
      rightRx = form.querySelector('.la-right-rx-container');
      leftRx = form.querySelector('.la-left-rx-container');
      if (!rightRx || !leftRx || !api.areRxContainersReady(rightRx, leftRx)) {
        return false;
      }
    }

    var section = api.buildRxSection(rightRx, leftRx);
    if (!section) {
      return false;
    }

    var uploadWrapper = card.querySelector('.la-upload-wrapper, .ciw-la-upload-rx-section--file');
    var pdSection =
      card.querySelector('.ciw-la-manual-rx-section--pd, [data-ciw-la-upload-pd-fallback="1"], .la-pd-container') ||
      null;

    if (uploadWrapper && uploadWrapper.parentNode === card) {
      if (uploadWrapper.nextSibling) {
        card.insertBefore(section, uploadWrapper.nextSibling);
      } else {
        card.appendChild(section);
      }
    } else if (pdSection && pdSection.parentNode === card) {
      card.insertBefore(section, pdSection);
    } else {
      card.insertBefore(section, card.firstChild);
    }

    placeExtractionDisclaimer(form, card);
    hideOrphanUploadPdContainers(form, card);
    document.dispatchEvent(new CustomEvent('ciw-la-upload-rx:rx-grid-attached'));
    return true;
  }

  /* LA injects .la-extraction-message after OCR — pin it under the upload box,
     above the Right (OD) grid. */
  function placeExtractionDisclaimer(form, card) {
    if (!form || !card) {
      return false;
    }

    var msg = form.querySelector('.la-extraction-message');
    if (!msg) {
      return false;
    }

    msg.classList.add('ciw-la-upload-rx-extraction-message');

    var uploadWrapper = card.querySelector('.la-upload-wrapper, .ciw-la-upload-rx-section--file');
    var rxSection = card.querySelector('.ciw-la-manual-rx-section--rx');

    if (rxSection && rxSection.parentNode === card) {
      card.insertBefore(msg, rxSection);
      return true;
    }

    if (uploadWrapper && uploadWrapper.parentNode === card) {
      if (uploadWrapper.nextSibling) {
        card.insertBefore(msg, uploadWrapper.nextSibling);
      } else {
        card.appendChild(msg);
      }
      return true;
    }

    card.insertBefore(msg, card.firstChild);
    return true;
  }

  /* After PD is in the upload card, LA often leaves a second .la-pd-container in
     .la-fields-wrapper — that orphan shows the duplicate "Pupillary Distance (PD)". */
  function hideOrphanUploadPdContainers(form, card) {
    if (!form || !card) {
      return;
    }

    if (!card.querySelector('.la-pd-container, .ciw-la-manual-rx-section--pd')) {
      return;
    }

    var api = shared();
    form.querySelectorAll('.la-pd-container').forEach(function (pd) {
      if (card.contains(pd)) {
        return;
      }

      pd.classList.add('ciw-la-upload-rx-orphan-pd');
      if (api && typeof api.hideElement === 'function') {
        api.hideElement(pd);
      }
      pd.style.setProperty('display', 'none', 'important');
      pd.style.setProperty('visibility', 'hidden', 'important');
      pd.style.setProperty('height', '0', 'important');
      pd.style.setProperty('overflow', 'hidden', 'important');
      pd.style.setProperty('margin', '0', 'important');
      pd.style.setProperty('padding', '0', 'important');
    });
  }

  function forceUploadFormRerenderForPd() {
    return false;
  }

  function ensureUploadPdOnForm(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || !isUploadWrapperActive(form)) {
      return false;
    }

    var card = form.querySelector('.ciw-la-upload-rx-card');
    if (!card) {
      return false;
    }

    if (attachUploadPd(form, card)) {
      return true;
    }

    return false;
  }

  function stopUploadPdObserver() {
    if (!uploadPdObserver) {
      return;
    }

    uploadPdObserver.disconnect();
    uploadPdObserver = null;
  }

  function startUploadPdObserver(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || uploadPdObserver) {
      return;
    }

    uploadPdObserver = new MutationObserver(function () {
      var card = form.querySelector('.ciw-la-upload-rx-card');
      if (!card) {
        return;
      }

      if (uploadCardHasVisiblePd(card)) {
        stopUploadPdObserver();
        return;
      }

      var pdContainer = findUploadPdContainer(form);
      if (pdContainer && !pdContainer.closest('.ciw-la-upload-rx-card')) {
        attachUploadPd(form, card);
        return;
      }

      if (card.querySelector('.ciw-la-manual-rx-section--pd, [data-ciw-la-upload-pd-fallback="1"]')) {
        attachUploadPd(form, card);
      }
    });

    uploadPdObserver.observe(form, {
      childList: true,
      subtree: true
    });
  }

  var uploadExtractObserver = null;
  var uploadExtractEnhanceTimer = null;

  function stopUploadExtractObserver() {
    if (uploadExtractObserver) {
      uploadExtractObserver.disconnect();
      uploadExtractObserver = null;
    }
    if (uploadExtractEnhanceTimer) {
      window.clearTimeout(uploadExtractEnhanceTimer);
      uploadExtractEnhanceTimer = null;
    }
  }

  /* After OCR fill, LA injects / updates .la-right-rx-container selects.
     Re-run enhance so we fold them into .ciw-la-rx-grid. */
  function startUploadExtractObserver(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    if (uploadExtractObserver) {
      return;
    }

    uploadExtractObserver = new MutationObserver(function () {
      var card = form.querySelector('.ciw-la-upload-rx-card');
      if (!card || !form.classList.contains('ciw-la-upload-rx-form--mobile')) {
        return;
      }

      var msg = form.querySelector('.la-extraction-message');
      if (msg && !card.contains(msg)) {
        placeExtractionDisclaimer(form, card);
      }

      hideOrphanUploadPdContainers(form, card);

      var titleEl =
        document.querySelector('#lensadvizor-prescription-modal #la_prescriptionSelect_title') ||
        document.querySelector('#lensadvizor-prescription-modal .la-wrapper-heading h3');
      if (
        titleEl &&
        String(titleEl.textContent || '').replace(/\s+/g, ' ').trim() !== UPLOAD_STEP_TITLE
      ) {
        syncUploadStepTitle();
      }

      if (!hasExtractableRxContainers(form)) {
        return;
      }

      if (uploadCardHasRxGrid(card)) {
        var api = shared();
        var rightRx = form.querySelector('.la-right-rx-container');
        var leftRx = form.querySelector('.la-left-rx-container');
        if (api && typeof api.hideElement === 'function') {
          api.hideElement(rightRx);
          api.hideElement(leftRx);
        }
        if (msg && !card.contains(msg)) {
          placeExtractionDisclaimer(form, card);
        }
        return;
      }

      if (uploadExtractEnhanceTimer) {
        window.clearTimeout(uploadExtractEnhanceTimer);
      }
      uploadExtractEnhanceTimer = window.setTimeout(function () {
        uploadExtractEnhanceTimer = null;
        enhanceUploadRxForm();
      }, 60);
    });

    uploadExtractObserver.observe(form, {
      childList: true,
      subtree: true
    });
  }

  function findUploadPdContainer(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    var scopes = [form, document.querySelector('#lensadvizor-prescription-modal')];

    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (!scope) {
        continue;
      }

      var containers = scope.querySelectorAll('.la-pd-container');
      for (var i = 0; i < containers.length; i++) {
        var pdContainer = containers[i];
        if (pdContainer.closest('.ciw-la-upload-rx-card')) {
          continue;
        }
        if (pdContainer.closest('.ciw-la-manual-rx-card:not(.ciw-la-upload-rx-card)')) {
          continue;
        }
        return pdContainer;
      }

      var pdFields = scope.querySelector('#la-pd-fields-container');
      if (pdFields) {
        var pdWrapper =
          pdFields.closest('.la-pd-container') ||
          pdFields.closest('.la-prescription-fields-wrapper') ||
          pdFields.closest('.la-fields-wrapper');
        if (
          pdWrapper &&
          !pdWrapper.closest('.ciw-la-upload-rx-card') &&
          !pdWrapper.closest('.ciw-la-manual-rx-card:not(.ciw-la-upload-rx-card)')
        ) {
          return pdWrapper;
        }
      }
    }

    return null;
  }

  function insertUploadPdInCard(card, pdContainer) {
    var confirmRow = card.querySelector(':scope > .ciw-la-manual-rx-confirm-row');
    if (confirmRow) {
      card.insertBefore(pdContainer, confirmRow);
      return;
    }

    card.appendChild(pdContainer);
  }

  /* Desktop only — PD was landing above the upload box because it attached
     before the file section moved into the card. Keep: upload → AI note → Rx → PD → confirm.
     Only move nodes when order is wrong — re-appending an open <select> closes the dropdown. */
  function orderUploadCardDesktop(card) {
    if (!card || !window.matchMedia('(min-width: 750px)').matches) {
      return;
    }

    var upload = card.querySelector('.la-upload-wrapper, .ciw-la-upload-rx-section--file');
    var msg = card.querySelector('.la-extraction-message, .ciw-la-upload-rx-extraction-message');
    var rx = card.querySelector('.ciw-la-manual-rx-section--rx');
    var pd = card.querySelector('.ciw-la-manual-rx-section--pd, .la-pd-container');
    var confirm = card.querySelector(':scope > .ciw-la-manual-rx-confirm-row');

    var desired = [upload, msg, rx, pd, confirm].filter(Boolean);
    if (desired.length < 2) {
      return;
    }

    var children = Array.prototype.slice.call(card.children);
    var indexes = desired.map(function (el) {
      return children.indexOf(el);
    });
    var alreadyOrdered = indexes.every(function (index, i) {
      return index >= 0 && (i === 0 || index > indexes[i - 1]);
    });
    if (alreadyOrdered) {
      return;
    }

    desired.forEach(function (el) {
      card.appendChild(el);
    });
  }

  function formatUploadPdValue(val) {
    var num = parseFloat(val);
    if (isNaN(num)) {
      return '';
    }
    return num.toFixed(2);
  }

  function getUploadPdFieldValues() {
    var la = window.LensAdvizor;
    if (!la || !la.options || !la.options.fieldValues) {
      return null;
    }

    return la.options.fieldValues;
  }

  function defaultUploadPdValues() {
    var values = [];
    for (var v = 50; v <= 80.01; v += 0.5) {
      values.push(Math.round(v * 100) / 100);
    }
    return values;
  }

  function resolveUploadPdFieldValues() {
    var fieldValues = getUploadPdFieldValues();
    var singlePD =
      fieldValues && fieldValues.singlePD && fieldValues.singlePD.length
        ? fieldValues.singlePD
        : defaultUploadPdValues();
    var dualPD =
      fieldValues && fieldValues.dualPD && fieldValues.dualPD.length
        ? fieldValues.dualPD
        : singlePD;

    return {
      singlePD: singlePD,
      dualPD: dualPD
    };
  }

  function buildUploadPdLabelCell() {
    var label = document.createElement('div');
    label.className = 'ciw-la-pd-split__label';

    var labelText = document.createElement('span');
    labelText.className = 'ciw-la-pd-split__label-text';
    labelText.textContent = 'PD';

    var helpBtn = document.createElement('button');
    helpBtn.type = 'button';
    helpBtn.className = 'ciw-la-rx-help-trigger__icon ciw-la-pd-help-trigger';
    helpBtn.setAttribute('data-ciw-la-rx-read-help-open', '');
    helpBtn.setAttribute('data-ciw-la-rx-read-help-target', 'ciw-la-rx-read-help-pd');
    helpBtn.setAttribute('aria-label', 'How to read PD on your prescription');
    helpBtn.innerHTML = '<span aria-hidden="true">?</span>';

    label.appendChild(labelText);
    label.appendChild(helpBtn);
    return label;
  }

  function uploadPdDualModeEnabled(pdContainer) {
    var dualCheckbox = pdContainer && pdContainer.querySelector('.ciw-la-manual-rx-dual-pd .ciw-la-manual-rx-checkbox__input');
    if (dualCheckbox) {
      return dualCheckbox.checked;
    }

    var dualRadio = pdContainer && pdContainer.querySelector('#la-pd-field-dual');
    return !!(dualRadio && dualRadio.checked);
  }

  function findUploadSinglePdSelect(pdFields) {
    if (!pdFields) {
      return null;
    }

    var splitSelect = pdFields.querySelector(
      '.ciw-la-pd-split:not(.ciw-la-pd-split--dual) .ciw-la-pd-split__field select'
    );
    if (splitSelect) {
      return splitSelect;
    }

    return (
      pdFields.querySelector('#la-pd-value') ||
      pdFields.querySelector('select[data-field="value"]') ||
      pdFields.querySelector('select[name="la-pd-value"]') ||
      pdFields.querySelector('.la-form-item select')
    );
  }

  function ensureUploadSinglePdSelect(pdFields, selected) {
    var select = findUploadSinglePdSelect(pdFields);
    if (select) {
      return select;
    }

    var fieldValues = resolveUploadPdFieldValues();
    var singleItem = document.createElement('div');
    singleItem.className = 'la-form-item la-mt-1';

    select = document.createElement('select');
    select.className = 'la-form-select';
    select.id = 'la-pd-value';
    select.name = 'la-pd-value';
    select.setAttribute('data-field', 'value');
    select.required = true;
    appendPdSelectOptions(select, fieldValues.singlePD, selected);
    singleItem.appendChild(select);
    pdFields.appendChild(singleItem);
    return select;
  }

  function hideUploadPdFieldSiblings(pdFields, api) {
    if (!pdFields || !pdFields.querySelector('.ciw-la-pd-split')) {
      return;
    }

    pdFields.querySelectorAll(':scope > *:not(.ciw-la-pd-split)').forEach(function (node) {
      if (api && api.hideElement) {
        api.hideElement(node);
      } else {
        node.classList.add('ciw-la-manual-rx-hidden');
      }
    });
  }

  function finalizeUploadPdVisibility(pdContainer) {
    if (!pdContainer) {
      return;
    }

    var visibleTargets = pdContainer.querySelectorAll(
      '#la-pd-fields-container, .ciw-la-manual-rx-pd-fields, .ciw-la-pd-split, .ciw-la-pd-split--dual, .ciw-la-pd-split__label, .ciw-la-pd-split__field, #la-pd-value, select[data-field="value"], .ciw-la-rx-select, .ciw-la-rx-select__trigger'
    );

    visibleTargets.forEach(function (node) {
      node.classList.remove('ciw-la-manual-rx-hidden');
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
      node.style.removeProperty('opacity');
      node.style.removeProperty('height');
      node.style.removeProperty('max-height');
      node.style.removeProperty('overflow');
    });

    pdContainer.classList.remove('ciw-la-manual-rx-hidden');
    pdContainer.style.removeProperty('display');
    pdContainer.style.removeProperty('visibility');
    pdContainer.style.removeProperty('opacity');

    var split = pdContainer.querySelector('.ciw-la-pd-split:not(.ciw-la-pd-split--dual)');
    if (split) {
      split.style.setProperty('display', 'grid', 'important');
    }
  }

  function ensureUploadPdSplitBox(pdContainer, api) {
    if (!pdContainer) {
      return false;
    }

    var pdFields = pdContainer.querySelector('#la-pd-fields-container');
    if (!pdFields) {
      return false;
    }

    pdFields.classList.add('ciw-la-manual-rx-pd-fields');
    revealUploadPdFields(pdContainer, api);

    if (uploadPdDualModeEnabled(pdContainer)) {
      return api && api.syncPdLayout ? api.syncPdLayout(pdFields, pdContainer) : false;
    }

    pdFields.classList.remove('ciw-la-manual-rx-pd-fields--dual');

    var existingSplit = pdFields.querySelector('.ciw-la-pd-split:not(.ciw-la-pd-split--dual)');
    if (existingSplit && existingSplit.querySelector('.ciw-la-pd-split__field select, .ciw-la-rx-select')) {
      hideUploadPdFieldSiblings(pdFields, api);
      pdFields.classList.remove('ciw-la-manual-rx-pd-fields--pending');
      pdFields.classList.add('ciw-la-manual-rx-pd-fields--ready');
      return true;
    }

    if (existingSplit) {
      existingSplit.remove();
    }

    pdFields.querySelectorAll('.ciw-la-pd-split--dual').forEach(function (node) {
      node.remove();
    });

    pdFields.querySelectorAll('.ciw-la-manual-rx-hidden, .la-form-item').forEach(function (node) {
      node.classList.remove('ciw-la-manual-rx-hidden');
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
      node.style.removeProperty('opacity');
    });

    var state = getUploadPdState();
    var select = ensureUploadSinglePdSelect(pdFields, state.value);
    if (!select) {
      return false;
    }

    var split = document.createElement('div');
    split.className = 'ciw-la-pd-split';
    split.appendChild(buildUploadPdLabelCell());

    var field = document.createElement('div');
    field.className = 'ciw-la-pd-split__field';
    field.appendChild(select);
    split.appendChild(field);

    pdFields.insertBefore(split, pdFields.firstChild);
    hideUploadPdFieldSiblings(pdFields, api);

    pdFields.classList.remove('ciw-la-manual-rx-pd-fields--pending');
    pdFields.classList.add('ciw-la-manual-rx-pd-fields--ready');
    return true;
  }

  function bindUploadPdLayoutRefresh(pdContainer, api) {
    if (!pdContainer || pdContainer.dataset.ciwLaUploadPdLayoutBound === '1') {
      return;
    }

    pdContainer.dataset.ciwLaUploadPdLayoutBound = '1';

    var dualCheckbox = pdContainer.querySelector('.ciw-la-manual-rx-dual-pd .ciw-la-manual-rx-checkbox__input');
    if (!dualCheckbox) {
      return;
    }

    dualCheckbox.addEventListener('change', function () {
      window.setTimeout(function () {
        ensureUploadPdSplitBox(pdContainer, api);
        document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:pd-synced'));
      }, 0);
    });
  }

  function getUploadPdState() {
    var la = window.LensAdvizor;
    var pd = la && la.response && la.response.manually && la.response.manually.pd ? la.response.manually.pd : null;

    if (!pd) {
      return {
        type: 'Single PD',
        value: null,
        right: null,
        left: null,
        usage: 'distance'
      };
    }

    return {
      type: pd.type || 'Single PD',
      value: pd.value != null ? pd.value : null,
      right: pd.right != null ? pd.right : null,
      left: pd.left != null ? pd.left : null,
      usage: pd.usage || 'distance'
    };
  }

  function syncUploadPdToLensAdvizor(update) {
    var la = window.LensAdvizor;
    if (!la) {
      return;
    }

    if (!la.response) {
      la.response = {};
    }

    if (!la.response.manually) {
      la.response.manually = {};
    }

    la.response.manually.pd = Object.assign({}, getUploadPdState(), update || {});
  }

  function appendPdSelectOptions(select, values, selected) {
    var empty = document.createElement('option');
    empty.className = 'la-option-select';
    empty.value = '';
    empty.textContent = 'Choose';
    select.appendChild(empty);

    (values || []).forEach(function (value) {
      var formatted = formatUploadPdValue(value);
      var option = document.createElement('option');
      option.className = 'la-option-select';
      option.value = formatted;
      option.textContent = formatted;
      if (selected && formatUploadPdValue(selected) === formatted) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }

  function createUploadPdRadioRow(state) {
    var radioRow = document.createElement('div');
    radioRow.className = 'la-flex la-column-gap-1-5';

    var singleWrap = document.createElement('div');
    singleWrap.className = 'la-flex la-column-gap-5';
    var singleRadio = document.createElement('input');
    singleRadio.type = 'radio';
    singleRadio.name = 'la-pd-field';
    singleRadio.value = 'Single PD';
    singleRadio.className = 'la-pd-field';
    singleRadio.id = 'la-pd-field-single';
    singleRadio.checked = state.type !== 'Dual PD';
    var singleLabel = document.createElement('label');
    singleLabel.className = 'la-form-field-label';
    singleLabel.setAttribute('for', 'la-pd-field-single');
    singleLabel.textContent = 'Single PD';
    singleWrap.appendChild(singleRadio);
    singleWrap.appendChild(singleLabel);

    var dualWrap = document.createElement('div');
    dualWrap.className = 'la-flex la-column-gap-5';
    var dualRadio = document.createElement('input');
    dualRadio.type = 'radio';
    dualRadio.name = 'la-pd-field';
    dualRadio.value = 'Dual PD';
    dualRadio.className = 'la-pd-field';
    dualRadio.id = 'la-pd-field-dual';
    dualRadio.checked = state.type === 'Dual PD';
    var dualLabel = document.createElement('label');
    dualLabel.className = 'la-form-field-label';
    dualLabel.setAttribute('for', 'la-pd-field-dual');
    dualLabel.textContent = 'Dual PD';
    dualWrap.appendChild(dualRadio);
    dualWrap.appendChild(dualLabel);

    radioRow.appendChild(singleWrap);
    radioRow.appendChild(dualWrap);
    return radioRow;
  }

  function bindUploadFallbackPd(pdContainer) {
    if (!pdContainer || pdContainer.dataset.ciwLaUploadPdBound === '1') {
      return;
    }

    pdContainer.dataset.ciwLaUploadPdBound = '1';

    var pdFields = pdContainer.querySelector('#la-pd-fields-container');
    if (!pdFields) {
      return;
    }

    function readFromDom() {
      var singleSelect = pdFields.querySelector('#la-pd-value');
      var rightSelect = pdFields.querySelector('select[data-field="right"], select[name="la-pd-right"]');
      var leftSelect = pdFields.querySelector('select[data-field="left"], select[name="la-pd-left"]');
      var dualRadio = pdContainer.querySelector('#la-pd-field-dual');
      var isDual = !!(dualRadio && dualRadio.checked);

      if (isDual) {
        syncUploadPdToLensAdvizor({
          type: 'Dual PD',
          value: null,
          right: rightSelect && rightSelect.value ? rightSelect.value : null,
          left: leftSelect && leftSelect.value ? leftSelect.value : null
        });
        return;
      }

      syncUploadPdToLensAdvizor({
        type: 'Single PD',
        value: singleSelect && singleSelect.value ? singleSelect.value : null,
        right: null,
        left: null
      });
    }

    pdFields.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', readFromDom);
    });

    pdContainer.querySelectorAll('input.la-pd-field').forEach(function (radio) {
      radio.addEventListener('change', function () {
        window.setTimeout(readFromDom, 0);
      });
    });

    readFromDom();
  }

  function ensureUploadFallbackPd(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return null;
    }

    var existing =
      form.querySelector('.ciw-la-upload-rx-card [data-ciw-la-upload-pd-fallback="1"]') ||
      form.querySelector('[data-ciw-la-upload-pd-fallback="1"]');
    if (existing) {
      return existing;
    }

    var fieldValues = resolveUploadPdFieldValues();
    var state = getUploadPdState();
    var dualValues = fieldValues.dualPD;
    var isDual = state.type === 'Dual PD';

    var pdContainer = document.createElement('div');
    pdContainer.className = 'la-prescription-fields-wrapper la-pd-container';
    pdContainer.setAttribute('data-ciw-la-upload-pd-fallback', '1');

    pdContainer.appendChild(createUploadPdRadioRow(state));

    var pdFields = document.createElement('div');
    pdFields.className = 'la-form-flex la-column-gap-1-5 la-pd-form';
    pdFields.id = 'la-pd-fields-container';

    var singleItem = document.createElement('div');
    singleItem.className = 'la-form-item la-mt-1';
    singleItem.style.display = isDual ? 'none' : '';
    var singleSelect = document.createElement('select');
    singleSelect.className = 'la-form-select';
    singleSelect.id = 'la-pd-value';
    singleSelect.name = 'la-pd-value';
    singleSelect.setAttribute('data-field', 'value');
    singleSelect.required = true;
    appendPdSelectOptions(singleSelect, fieldValues.singlePD, state.value);
    singleItem.appendChild(singleSelect);
    pdFields.appendChild(singleItem);

    var rightItem = document.createElement('div');
    rightItem.className = 'la-form-item';
    rightItem.style.display = isDual ? '' : 'none';
    var rightLabel = document.createElement('label');
    rightLabel.className = 'la-form-helper-label';
    rightLabel.setAttribute('for', 'la-pd-right');
    rightLabel.textContent = 'Right';
    var rightSelect = document.createElement('select');
    rightSelect.className = 'la-form-select';
    rightSelect.id = 'la-pd-right';
    rightSelect.name = 'la-pd-right';
    rightSelect.setAttribute('data-field', 'right');
    rightSelect.required = true;
    appendPdSelectOptions(rightSelect, dualValues, state.right);
    rightItem.appendChild(rightLabel);
    rightItem.appendChild(rightSelect);
    pdFields.appendChild(rightItem);

    var leftItem = document.createElement('div');
    leftItem.className = 'la-form-item';
    leftItem.style.display = isDual ? '' : 'none';
    var leftLabel = document.createElement('label');
    leftLabel.className = 'la-form-helper-label';
    leftLabel.setAttribute('for', 'la-pd-left');
    leftLabel.textContent = 'Left';
    var leftSelect = document.createElement('select');
    leftSelect.className = 'la-form-select';
    leftSelect.id = 'la-pd-left';
    leftSelect.name = 'la-pd-left';
    leftSelect.setAttribute('data-field', 'left');
    leftSelect.required = true;
    appendPdSelectOptions(leftSelect, dualValues, state.left);
    leftItem.appendChild(leftLabel);
    leftItem.appendChild(leftSelect);
    pdFields.appendChild(leftItem);

    pdContainer.appendChild(pdFields);
    bindUploadFallbackPd(pdContainer);

    return pdContainer;
  }

  function revealUploadPdFields(pdContainer, api) {
    if (!pdContainer) {
      return;
    }

    revealUploadNode(pdContainer);
    pdContainer.classList.remove('ciw-la-manual-rx-hidden');

    var pdFields = pdContainer.querySelector('#la-pd-fields-container');
    if (!pdFields) {
      return;
    }

    pdFields.classList.remove('ciw-la-manual-rx-hidden');
    pdFields.querySelectorAll('.ciw-la-manual-rx-hidden, .la-form-item, .ciw-la-pd-split').forEach(function (node) {
      if (api && api.revealElement) {
        api.revealElement(node);
      } else {
        node.classList.remove('ciw-la-manual-rx-hidden');
        node.style.removeProperty('display');
        node.style.removeProperty('visibility');
        node.style.removeProperty('opacity');
      }
    });
  }

  function syncUploadPdInCard(pdContainer, api) {
    var pdFields = pdContainer && pdContainer.querySelector('#la-pd-fields-container');
    if (!pdFields || !api || !api.syncPdLayout) {
      return false;
    }

    return api.syncPdLayout(pdFields, pdContainer);
  }

  function attachUploadPd(form, card) {
    var api = shared();
    if (!api || !form || !card) {
      return false;
    }

    if (uploadCardHasVisiblePd(card)) {
      orderUploadCardDesktop(card);
      return true;
    }

    var pdContainer =
      card.querySelector('.ciw-la-manual-rx-section--pd, [data-ciw-la-upload-pd-fallback="1"], .la-pd-container') ||
      findUploadPdContainer(form);

    if (!pdContainer) {
      pdContainer = ensureUploadFallbackPd(form);
    }
    if (!pdContainer) {
      return false;
    }

    revealUploadPdFields(pdContainer, api);

    if (pdContainer.dataset.ciwLaUploadPdFallback === '1') {
      bindUploadFallbackPd(pdContainer);
    }

    api.enhancePdSection(pdContainer);
    bindUploadPdLayoutRefresh(pdContainer, api);

    ensureUploadPdSplitBox(pdContainer, api);
    if (uploadPdDualModeEnabled(pdContainer)) {
      syncUploadPdInCard(pdContainer, api);
      ensureUploadPdSplitBox(pdContainer, api);
    }
    finalizeUploadPdVisibility(pdContainer);

    if (!pdContainer.querySelector('.ciw-la-manual-rx-section__label')) {
      var pdLabel = document.createElement('div');
      pdLabel.className = 'ciw-la-manual-rx-section__label';
      pdLabel.textContent = 'Pupillary distance (PD)';
      pdContainer.insertBefore(pdLabel, pdContainer.firstChild);
    }

    if (!card.contains(pdContainer)) {
      insertUploadPdInCard(card, pdContainer);
    }

    orderUploadCardDesktop(card);

    if (uploadCardHasVisiblePd(card)) {
      document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:pd-synced'));
      return true;
    }

    [0, 100, 300, 800].forEach(function (delay) {
      window.setTimeout(function () {
        if (uploadCardHasVisiblePd(card)) {
          orderUploadCardDesktop(card);
          return;
        }
        ensureUploadPdSplitBox(pdContainer, api);
        finalizeUploadPdVisibility(pdContainer);
        orderUploadCardDesktop(card);
        document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:pd-synced'));
        document.dispatchEvent(new CustomEvent('ciw-la-upload-rx:enhanced'));
      }, delay);
    });

    return uploadCardHasVisiblePd(card);
  }

  function markUploadStep(form) {
    if (!form) {
      return;
    }

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.add('ciw-la-upload-rx-step--mobile');
    }
  }

  function clearUploadStepMark(form) {
    if (!form) {
      return;
    }

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-upload-rx-step--mobile');
    }
  }

  function applyUploadDesktopLayout(form) {
    if (!window.matchMedia('(min-width: 750px)').matches || !form) {
      return;
    }

    if (!form.classList.contains('ciw-la-upload-rx-form--mobile')) {
      return;
    }

    markUploadStep(form);

    var contentBody = form.closest('.la-prescription-modal-content-body');
    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    var card = form.querySelector('.ciw-la-upload-rx-card');
    var heading = form.querySelector('.ciw-la-upload-rx-heading');

    if (contentBody) {
      contentBody.style.setProperty('padding-left', 'max(35px, env(safe-area-inset-left, 0px))', 'important');
      contentBody.style.setProperty('padding-right', 'max(35px, env(safe-area-inset-right, 0px))', 'important');
      contentBody.dataset.ciwLaUploadGutter = '1';
    }

    if (fieldsWrapper) {
      fieldsWrapper.style.setProperty('box-sizing', 'border-box', 'important');
      fieldsWrapper.style.setProperty('width', '100%', 'important');
      fieldsWrapper.style.setProperty('max-width', '100%', 'important');
      fieldsWrapper.style.setProperty('padding-left', 'max(18px, env(safe-area-inset-left, 0px))', 'important');
      fieldsWrapper.style.setProperty('padding-right', 'max(18px, env(safe-area-inset-right, 0px))', 'important');
    }

    if (card) {
      card.style.setProperty('width', '100%', 'important');
      card.style.setProperty('max-width', '100%', 'important');
      card.style.setProperty('box-sizing', 'border-box', 'important');
    }

    if (heading) {
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('max-width', '100%', 'important');
    }
  }

  function syncUploadDesktop(form) {
    if (!form || !window.matchMedia('(min-width: 750px)').matches) {
      return;
    }

    var card = form.querySelector('.ciw-la-upload-rx-card');
    if (!card) {
      return;
    }

    applyUploadDesktopLayout(form);
    attachUploadPd(form, card);
    orderUploadCardDesktop(card);
  }

  var uploadDesktopWatch = null;

  function stopUploadDesktopWatch() {
    if (!uploadDesktopWatch) {
      return;
    }

    window.clearInterval(uploadDesktopWatch);
    uploadDesktopWatch = null;
  }

  function startUploadDesktopWatch() {
    if (!window.matchMedia('(min-width: 750px)').matches || uploadDesktopWatch) {
      return;
    }

    uploadDesktopWatch = window.setInterval(function () {
      var form = document.querySelector(FORM_SELECTOR);
      if (!form || !form.classList.contains('ciw-la-upload-rx-form--mobile')) {
        stopUploadDesktopWatch();
        stopUploadPdObserver();
        return;
      }

      applyUploadDesktopLayout(form);
      var card = form.querySelector('.ciw-la-upload-rx-card');
      if (!card) {
        return;
      }

      /* Don't call syncUploadDesktop / orderUploadCardDesktop on every tick —
         re-parenting the PD node closes an open dropdown. */
      if (!uploadCardHasVisiblePd(card)) {
        attachUploadPd(form, card);
      }
    }, 250);
  }

  function resetUploadDesktopLayout(form) {
    if (!form) {
      return;
    }

    var contentBody = form.closest('.la-prescription-modal-content-body');
    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    var card = form.querySelector('.ciw-la-upload-rx-card');
    var heading = form.querySelector('.ciw-la-upload-rx-heading');

    if (contentBody && contentBody.dataset.ciwLaUploadGutter === '1') {
      contentBody.style.removeProperty('padding-left');
      contentBody.style.removeProperty('padding-right');
      delete contentBody.dataset.ciwLaUploadGutter;
    }

    if (fieldsWrapper) {
      fieldsWrapper.style.removeProperty('box-sizing');
      fieldsWrapper.style.removeProperty('width');
      fieldsWrapper.style.removeProperty('max-width');
      fieldsWrapper.style.removeProperty('padding-left');
      fieldsWrapper.style.removeProperty('padding-right');
    }

    if (card) {
      card.style.removeProperty('width');
      card.style.removeProperty('max-width');
      card.style.removeProperty('box-sizing');
    }

    if (heading) {
      heading.style.removeProperty('width');
      heading.style.removeProperty('max-width');
    }

    clearUploadStepMark(form);
  }

  function uploadCardMissingConfirm(form, card) {
    var api = shared();
    if (!card || !api) {
      return true;
    }

    if (api.isConfirmInCard && api.isConfirmInCard(form, card)) {
      return false;
    }

    return !findUploadConfirmRowInCard(card);
  }

  function clearStaleManualShell(form) {
    if (!form) {
      return false;
    }

    var staleCard = form.querySelector('.ciw-la-manual-rx-card--mobile:not(.ciw-la-upload-rx-card)');
    if (!staleCard) {
      return false;
    }

    var api = shared();
    var pdContainer = staleCard.querySelector('.la-pd-container');
    if (pdContainer) {
      form.appendChild(pdContainer);
    }

    staleCard.remove();

    form.querySelectorAll('.ciw-la-manual-rx-heading:not(.ciw-la-upload-rx-heading)').forEach(function (node) {
      node.remove();
    });

    form.classList.remove(
      'ciw-la-manual-rx-form',
      'ciw-la-manual-rx-form--mobile',
      'ciw-la-manual-rx--ready'
    );

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-manual-rx-step', 'ciw-la-manual-rx-step--mobile');
    }

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (uploadWrapper) {
      if (api && api.revealElement) {
        api.revealElement(uploadWrapper);
      } else {
        uploadWrapper.classList.remove('ciw-la-manual-rx-hidden');
        uploadWrapper.style.removeProperty('display');
        uploadWrapper.style.removeProperty('visibility');
      }
    }

    return true;
  }

  function isUploadStep(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return false;
    }

    if (!isEyeglassHost() || isContactLensHost()) {
      return false;
    }

    return isUploadPrescriptionStep(form);
  }

  var UPLOAD_STEP_TITLE = 'Upload prescription';

  function getLabelTitleText(titleEl) {
    if (!titleEl) {
      return '';
    }
    var translate = titleEl.querySelector('la-translate');
    return String((translate ? translate.textContent : titleEl.textContent) || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function setLabelTitleText(titleEl, text) {
    if (!titleEl || !text) {
      return false;
    }
    if (getLabelTitleText(titleEl) === text) {
      return false;
    }
    var translate = titleEl.querySelector('la-translate');
    if (translate) {
      translate.textContent = text;
    } else {
      titleEl.textContent = text;
    }
    return true;
  }

  /* Choice card on "Choose how to add your prescription" — LA still says Upload and Extract. */
  function renameUploadSubmissionCard() {
    if (!isEyeglassHost()) {
      return false;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) {
      return false;
    }

    var changed = false;
    modal.querySelectorAll('.la-label-btn-wrapper.la-submission-method, .la-label-btn.la-submission-type-0').forEach(
      function (node) {
        var wrapper = node.classList.contains('la-label-btn-wrapper')
          ? node
          : node.closest('.la-label-btn-wrapper');
        var btn = node.classList.contains('la-label-btn')
          ? node
          : node.querySelector('.la-label-btn');
        var titleEl =
          (btn && btn.querySelector('.la-label-title')) ||
          (wrapper && wrapper.querySelector('.la-label-title'));
        if (!titleEl) {
          return;
        }

        var text = getLabelTitleText(titleEl);
        if (/enter manually|email later|on file|send later/i.test(text)) {
          return;
        }

        var isUploadCard =
          (wrapper && wrapper.classList.contains('la-canUploadPrescription')) ||
          (btn && /\bla-submission-type-0\b/.test(btn.className)) ||
          /upload\s+and\s+extract|upload\s+file|^upload$/i.test(text);

        if (!isUploadCard) {
          return;
        }

        if (setLabelTitleText(titleEl, UPLOAD_STEP_TITLE)) {
          changed = true;
        }
      }
    );

    return changed;
  }

  function scheduleRenameUploadSubmissionCard() {
    [0, 50, 150, 400, 800, 1600].forEach(function (delay) {
      window.setTimeout(renameUploadSubmissionCard, delay);
    });
  }

  function syncUploadStepTitle() {
    var form = document.querySelector(FORM_SELECTOR);
    if (!form || !form.classList.contains('ciw-la-upload-rx-form--mobile')) {
      return false;
    }

    var changed = false;

    function applyTitle(el) {
      if (!el) {
        return;
      }
      var current = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (current === UPLOAD_STEP_TITLE) {
        return;
      }
      el.textContent = UPLOAD_STEP_TITLE;
      changed = true;
    }

    applyTitle(
      document.querySelector('#lensadvizor-prescription-modal #la_prescriptionSelect_title') ||
        document.querySelector('#lensadvizor-prescription-modal .la-wrapper-heading h3')
    );
    applyTitle(form.querySelector('.ciw-la-upload-rx-heading .ciw-la-manual-rx-heading__title'));

    return changed;
  }

  function buildUploadHeading() {
    var heading = document.createElement('div');
    heading.className = 'ciw-la-manual-rx-heading ciw-la-upload-rx-heading';

    var title = document.createElement('h3');
    title.className = 'ciw-la-manual-rx-heading__title';
    title.textContent = UPLOAD_STEP_TITLE;

    heading.appendChild(title);
    return heading;
  }

  function hideEmptyConfirmWrappers(form, card, api) {
    form.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (wrapper.closest('.la-upload-wrapper')) {
        if (
          wrapper.querySelector('#la-upload-confirmation, #ciw-la-upload-confirmation-fallback, input[type="checkbox"]') &&
          !wrapper.querySelector('select, input[type="file"], textarea')
        ) {
          if (api.hideUploadWrapperConfirmNode) {
            api.hideUploadWrapperConfirmNode(wrapper);
          } else {
            api.hideElement(wrapper);
          }
        }
        return;
      }

      if (card.contains(wrapper)) {
        return;
      }

      if (wrapper.querySelector('#la-upload-confirmation, #ciw-la-upload-confirmation-fallback')) {
        api.hideElement(wrapper);
        return;
      }

      if (
        wrapper.querySelector('input[type="checkbox"]') &&
        !wrapper.querySelector('select, input[type="file"], textarea, .la-form-item')
      ) {
        api.hideElement(wrapper);
      }
    });

    form.querySelectorAll('.la-checkox-wrapper-label, label.la-checkox-wrapper-label').forEach(function (label) {
      var inUploadWrapper = !!label.closest('.la-upload-wrapper');
      if (inUploadWrapper) {
        if (api.hideUploadWrapperConfirmNode) {
          api.hideUploadWrapperConfirmNode(label);
        } else {
          api.hideElement(label);
        }
        return;
      }

      if (card.contains(label)) {
        return;
      }

      var checkbox = label.querySelector('input[type="checkbox"]');
      if (checkbox && (checkbox.id === 'la-upload-confirmation' || checkbox.name === 'la-upload-confirmation')) {
        api.hideElement(label);
      }
    });
  }

  function isUploadPrescriptionConfirmCheckbox(input) {
    if (!input || input.type !== 'checkbox') {
      return false;
    }

    if (
      input.closest(
        '.ciw-la-manual-rx-dual-pd, .ciw-la-manual-rx-prism-toggle, .ciw-la-manual-rx-section--pd, .la-pd-container, .ciw-la-contact-quantity'
      )
    ) {
      return false;
    }

    if (input.id === 'la-upload-confirmation' || input.id === 'ciw-la-upload-confirmation-fallback') {
      return true;
    }

    if (input.name === 'la-upload-confirmation') {
      return true;
    }

    var label = input.closest('.la-checkox-wrapper-label, label');
    var text = label ? String(label.textContent || '').toLowerCase() : '';
    return text.indexOf('confirm') >= 0 || (text.indexOf('prescription') >= 0 && text.indexOf('correct') >= 0);
  }

  function resolveUploadConfirmRowFromCheckbox(checkbox) {
    if (!checkbox) {
      return null;
    }

    var row = checkbox.closest('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper');
    if (row) {
      return row;
    }

    var label = checkbox.closest('.la-checkox-wrapper-label, label');
    return label || checkbox.parentElement;
  }

  function isUploadCardConfirmRow(row) {
    if (!row) {
      return false;
    }

    if (
      row.classList.contains('ciw-la-manual-rx-section--pd') ||
      row.classList.contains('la-pd-container') ||
      row.classList.contains('ciw-la-manual-rx-section--prism')
    ) {
      return false;
    }

    var checkbox = row.querySelector('input[type="checkbox"]');
    return !!(checkbox && isUploadPrescriptionConfirmCheckbox(checkbox));
  }

  function findAllUploadConfirmRowsInCard(card) {
    if (!card) {
      return [];
    }

    var rows = [];
    var seen = new Set();

    card.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      if (!isUploadPrescriptionConfirmCheckbox(checkbox)) {
        return;
      }

      var row = resolveUploadConfirmRowFromCheckbox(checkbox);
      if (!row || !isUploadCardConfirmRow(row) || seen.has(row)) {
        return;
      }

      seen.add(row);
      rows.push(row);
    });

    return rows;
  }

  function findUploadConfirmRowInCard(card) {
    var rows = findAllUploadConfirmRowsInCard(card);
    if (!rows.length) {
      return null;
    }

    rows.sort(function (a, b) {
      return scoreUploadConfirmRow(b) - scoreUploadConfirmRow(a);
    });

    return rows[0];
  }

  function stripLensAdvizorConfirmInjection(label) {
    if (!label) {
      return;
    }

    var checkbox = label.querySelector('input[type="checkbox"]');
    var textSpan = label.querySelector('.ciw-la-manual-rx-confirm-text');

    Array.from(label.childNodes).forEach(function (node) {
      if (node === checkbox || node === textSpan) {
        return;
      }

      if (node.nodeType === Node.COMMENT_NODE) {
        node.remove();
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        node.remove();
        return;
      }

      node.remove();
    });
  }

  function finalizeUploadConfirmLabel(label, api) {
    if (!label) {
      return;
    }

    label.querySelectorAll('la-translate, .la-checkox-label').forEach(function (node) {
      node.remove();
    });

    var checkbox = label.querySelector('input[type="checkbox"]');
    var textSpans = label.querySelectorAll('.ciw-la-manual-rx-confirm-text');
    var textSpan = textSpans[0];

    textSpans.forEach(function (node, index) {
      if (index > 0) {
        node.remove();
      }
    });

    if (!textSpan) {
      textSpan = document.createElement('span');
      textSpan.className = 'ciw-la-manual-rx-confirm-text';
      label.appendChild(textSpan);
    }

    if (!String(textSpan.textContent || '').trim()) {
      var chunks = [];
      Array.from(label.childNodes).forEach(function (node) {
        if (node === checkbox || node === textSpan) {
          return;
        }

        var value = String(node.textContent || '').trim();
        if (value) {
          chunks.push(value);
        }
      });
      if (chunks.length) {
        textSpan.textContent = chunks.join(' ').trim();
      }
    }

    Array.from(label.childNodes).forEach(function (node) {
      if (node === checkbox || node === textSpan) {
        return;
      }

      node.remove();
    });

    if (api && api.syncPrescriptionConfirmLabel) {
      var ownerRow = label.closest('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper');
      if (ownerRow) {
        api.syncPrescriptionConfirmLabel(ownerRow);
      }
    }

    label.querySelectorAll('la-translate, .la-checkox-label').forEach(function (node) {
      node.remove();
    });

    label.querySelectorAll('.ciw-la-manual-rx-confirm-text').forEach(function (node, index) {
      if (index > 0) {
        node.remove();
      }
    });

    stripLensAdvizorConfirmInjection(label);
  }

  function scheduleUploadConfirmLabelCleanup(card) {
    if (!card) {
      return;
    }

    [0, 150, 500, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        var label = card.querySelector(
          '.ciw-la-manual-rx-confirm-row .la-checkox-wrapper-label, .ciw-la-manual-rx-confirm-row label'
        );
        stripLensAdvizorConfirmInjection(label);
      }, delay);
    });
  }

  function hideUploadConfirmNode(node, api) {
    if (!node) {
      return;
    }

    if (api && api.hideUploadWrapperConfirmNode) {
      api.hideUploadWrapperConfirmNode(node);
      return;
    }

    node.classList.add('ciw-la-manual-rx-hidden', 'ciw-la-upload-rx-hidden-confirm');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('opacity', '0', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('max-height', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
  }

  function revealUploadConfirmInCard(card, api) {
    var confirmRow = findUploadConfirmRowInCard(card);
    if (!confirmRow) {
      return false;
    }

    if (api && api.revealPrescriptionConfirmRow) {
      api.revealPrescriptionConfirmRow(confirmRow);
    } else {
      confirmRow.classList.remove('ciw-la-manual-rx-hidden');
      confirmRow.style.setProperty('display', 'block', 'important');
      confirmRow.style.setProperty('visibility', 'visible', 'important');
      confirmRow.style.setProperty('opacity', '1', 'important');
      confirmRow.style.removeProperty('height');
      confirmRow.style.removeProperty('max-height');
    }

    confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
    return true;
  }

  function scoreUploadConfirmRow(row) {
    var score = 0;

    if (row.querySelector('#la-upload-confirmation')) {
      score += 100;
    }

    if (row.dataset.ciwLaFallbackConfirm !== '1') {
      score += 50;
    }

    if (row.classList.contains('ciw-la-manual-rx-confirm-row')) {
      score += 25;
    }

    return score;
  }

  function dedupeUploadConfirmInCard(form, card, api) {
    if (!form || !card) {
      return;
    }

    api = api || shared();

    if (api && api.extractConfirmFromUploadWrapper) {
      api.extractConfirmFromUploadWrapper(form, card);
    }

    var confirmRows = findAllUploadConfirmRowsInCard(card);
    if (!confirmRows.length) {
      return;
    }

    confirmRows.sort(function (a, b) {
      return scoreUploadConfirmRow(b) - scoreUploadConfirmRow(a);
    });

    var keptRow = confirmRows[0];

    confirmRows.slice(1).forEach(function (row) {
      row.remove();
    });

    card.querySelectorAll('[data-ciw-la-upload-confirm-kept]').forEach(function (node) {
      node.removeAttribute('data-ciw-la-upload-confirm-kept');
    });

    if (keptRow.querySelector('#la-upload-confirmation')) {
      card.querySelectorAll('[data-ciw-la-fallback-confirm="1"]').forEach(function (node) {
        if (node !== keptRow) {
          node.remove();
        }
      });
    }

    if (keptRow.matches('.la-checkox-wrapper-label, label')) {
      var wrapped = document.createElement('div');
      wrapped.className = 'ciw-la-manual-rx-confirm-row la-prescription-fields-wrapper';
      keptRow.parentNode.insertBefore(wrapped, keptRow);
      wrapped.appendChild(keptRow);
      keptRow = wrapped;
    }

    if (keptRow.parentNode !== card) {
      card.appendChild(keptRow);
    }

    keptRow.classList.add('ciw-la-manual-rx-confirm-row');
    keptRow.dataset.ciwLaUploadConfirmKept = '1';

    if (api && api.normalizePrescriptionConfirmRow) {
      api.normalizePrescriptionConfirmRow(keptRow);
    }

    keptRow.querySelectorAll(':scope > .la-checkox-wrapper-label ~ .la-checkox-wrapper-label, :scope > label ~ label').forEach(function (node) {
      node.remove();
    });

    finalizeUploadConfirmLabel(keptRow.querySelector('.la-checkox-wrapper-label, label'), api);

    card.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      if (!isUploadPrescriptionConfirmCheckbox(checkbox)) {
        return;
      }

      var row = resolveUploadConfirmRowFromCheckbox(checkbox);
      if (!row || row === keptRow || keptRow.contains(row)) {
        return;
      }

      row.remove();
    });

    var uploadWrapper = card.querySelector('.la-upload-wrapper');
    if (uploadWrapper) {
      uploadWrapper.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        if (!isUploadPrescriptionConfirmCheckbox(checkbox)) {
          return;
        }

        hideUploadConfirmNode(resolveUploadConfirmRowFromCheckbox(checkbox) || checkbox, api);
      });
    }

    form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      if (!isUploadPrescriptionConfirmCheckbox(checkbox)) {
        return;
      }

      var row = resolveUploadConfirmRowFromCheckbox(checkbox);
      if (!row || card.contains(row)) {
        return;
      }

      if (uploadWrapper && uploadWrapper.contains(row)) {
        hideUploadConfirmNode(row, api);
        return;
      }

      row.remove();
    });

    if (api && api.hideNativeConfirmInsideUploadWrapper) {
      api.hideNativeConfirmInsideUploadWrapper(form, card);
    }

    scheduleUploadConfirmLabelCleanup(card);
  }

  function ensureUploadCardTail(form, card) {
    var api = shared();
    if (!api || !form || !card) {
      return;
    }

    if (api.extractConfirmFromUploadWrapper) {
      api.extractConfirmFromUploadWrapper(form, card);
    }

    if (api.hideNativeConfirmInsideUploadWrapper) {
      api.hideNativeConfirmInsideUploadWrapper(form, card);
    }

    var hasNativeConfirm =
      !!api.findPrescriptionConfirmCheckbox(form) ||
      !!form.querySelector('#la-upload-confirmation, #ciw-la-upload-confirmation-fallback');

    if (hasNativeConfirm) {
      api.ensurePrescriptionConfirmInCard(form, card);
    } else if (!findUploadConfirmRowInCard(card)) {
      api.ensureFallbackPrescriptionConfirm(form, card);
    }

    hideEmptyConfirmWrappers(form, card, api);
    attachUploadPd(form, card);

    dedupeUploadConfirmInCard(form, card, api);
    revealUploadConfirmInCard(card, api);

    if (api.isConfirmInCard && !api.isConfirmInCard(form, card)) {
      if (api.findPrescriptionConfirmCheckbox(form)) {
        api.ensurePrescriptionConfirmInCard(form, card);
      } else {
        api.ensureFallbackPrescriptionConfirm(form, card);
      }
      dedupeUploadConfirmInCard(form, card, api);
      revealUploadConfirmInCard(card, api);
      api.scheduleConfirmInCard(form);
    }

    api.refreshManualFooterInset();
  }

  function resetUploadEnhancement(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    setUploadStepActive(false);
    stopUploadExtractObserver();
    if (!form) {
      return;
    }

    var api = shared();
    var card = form.querySelector(UPLOAD_CARD_MARKER);
    if (!card) {
      form.classList.remove('ciw-la-upload-rx-form--mobile', 'ciw-la-upload-rx--ready');
      return;
    }

    if (api && typeof api.restoreNativeRxFields === 'function') {
      api.restoreNativeRxFields(form, card);
    }

    var rxSection = card.querySelector('.ciw-la-manual-rx-section--rx');
    if (rxSection) {
      rxSection.remove();
    }

    var pdContainer = card.querySelector('.la-pd-container');
    if (pdContainer) {
      if (pdContainer.dataset.ciwLaUploadPdFallback === '1') {
        pdContainer.remove();
      } else {
        form.appendChild(pdContainer);
      }
    }

    var uploadWrapper = card.querySelector('.la-upload-wrapper');
    if (uploadWrapper) {
      form.appendChild(uploadWrapper);
    }

    var confirmRow = card.querySelector('.ciw-la-manual-rx-confirm-row');
    if (confirmRow && confirmRow.dataset.ciwLaFallbackConfirm !== '1') {
      form.appendChild(confirmRow);
    } else if (confirmRow && confirmRow.dataset.ciwLaFallbackConfirm === '1') {
      confirmRow.remove();
    }

    card.remove();

    form.querySelectorAll('.ciw-la-upload-rx-heading').forEach(function (node) {
      node.remove();
    });

    form.classList.remove('ciw-la-upload-rx-form--mobile', 'ciw-la-upload-rx--ready');
    clearUploadStepMark(form);

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-upload-rx-step--mobile');
    }

    resetUploadDesktopLayout(form);
    stopUploadDesktopWatch();
    stopUploadPdObserver();

    if (api && api.stopManualFooterWatch) {
      api.stopManualFooterWatch();
    }
  }

  function insertUploadShell(form, heading, card) {
    var mount = form.querySelector('.la-fields-wrapper') || form;
    var anchor =
      mount.querySelector('.la-upload-wrapper, .la-pd-container, .la-wrapper-heading, .la-prescription-fields-wrapper') ||
      mount.firstChild;

    if (!mount.querySelector('.ciw-la-upload-rx-heading')) {
      if (anchor) {
        mount.insertBefore(heading, anchor);
      } else {
        mount.appendChild(heading);
      }
    }

    if (heading.nextElementSibling !== card) {
      heading.insertAdjacentElement('afterend', card);
    }
  }

  function ensureUploadCardShell(form) {
    var card = form.querySelector(UPLOAD_CARD_MARKER);
    if (card) {
      return card;
    }

    var heading = form.querySelector('.ciw-la-upload-rx-heading') || buildUploadHeading();
    card = document.createElement('div');
    card.className = 'ciw-la-manual-rx-card ciw-la-manual-rx-card--mobile ciw-la-upload-rx-card';
    insertUploadShell(form, heading, card);
    return card;
  }

  function enhanceUploadRxForm() {
    var form = document.querySelector(FORM_SELECTOR);
    if (!form) {
      syncUploadStepActiveState();
      return;
    }

    if (document.querySelector('.la-choose-prescription-wrapper')) {
      syncUploadStepActiveState();
      return;
    }

    if (isManualPrescriptionStep(form)) {
      if (
        form.classList.contains('ciw-la-upload-rx-form--mobile') ||
        form.querySelector('.ciw-la-upload-rx-card')
      ) {
        resetUploadEnhancement(form);
      }
      return;
    }

    if (!isUploadStep(form) && !isUploadCandidate(form)) {
      return;
    }

    clearStaleManualShell(form);

    primeUploadPdConfig();

    var api = shared();

    form.classList.add('ciw-la-upload-rx-form--mobile');
    setUploadStepActive(true);
    syncUploadStepTitle();

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.add('ciw-la-upload-rx-step--mobile');
    }

    markUploadStep(form);
    applyUploadDesktopLayout(form);

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (fieldsWrapper) {
      fieldsWrapper.style.setProperty('visibility', 'visible', 'important');
    }

    if (!api) {
      window.setTimeout(scheduleEnhance, 100);
      return;
    }

    var card = ensureUploadCardShell(form);

    if (isUploadEnhancementComplete(form, card)) {
      attachExtractedRxGrid(form, card);
      placeExtractionDisclaimer(form, card);
      hideOrphanUploadPdContainers(form, card);
      syncUploadStepTitle();
      syncUploadDesktop(form);
      orderUploadCardDesktop(card);
      api.ensureMobileManualFooter();
      startUploadExtractObserver(form);
      return;
    }

    api.hideElement(form.querySelector('.la-wrapper-heading'));
    api.hideElement(form.querySelector('.la-patient-name-wrapper'));
    form.querySelectorAll('.la-right-rx-container, .la-left-rx-container, .la-prism-field').forEach(api.hideElement);

    syncUploadDesktop(form);

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (uploadWrapper && !card.contains(uploadWrapper)) {
      revealUploadNode(uploadWrapper);
      uploadWrapper.classList.add('ciw-la-upload-rx-section--file');
      card.appendChild(uploadWrapper);
    }

    var pdContainer = findUploadPdContainer(form);
    if (pdContainer && !pdContainer.closest('.ciw-la-upload-rx-card')) {
      attachUploadPd(form, card);
    } else if (!uploadCardHasPd(card)) {
      attachUploadPd(form, card);
    }

    ensureUploadCardTail(form, card);
    attachUploadPd(form, card);
    attachExtractedRxGrid(form, card);
    placeExtractionDisclaimer(form, card);
    hideOrphanUploadPdContainers(form, card);
    orderUploadCardDesktop(card);

    if (uploadCardHasVisiblePd(card)) {
      form.classList.add('ciw-la-upload-rx--ready');
    } else {
      form.classList.remove('ciw-la-upload-rx--ready');
    }

    if (!uploadCardMissingConfirm(form, card)) {
      revealUploadConfirmInCard(card, api);
    }

    syncUploadDesktop(form);
    startUploadDesktopWatch();
    startUploadPdObserver(form);
    startUploadExtractObserver(form);
    syncUploadStepTitle();
    api.startManualFooterWatch();
    api.ensureMobileManualFooter();

    document.dispatchEvent(new CustomEvent('ciw-la-upload-rx:enhanced'));
  }

  var enhanceTimer = null;
  var enhanceRetryTimers = [];

  function clearEnhanceRetries() {
    enhanceRetryTimers.forEach(function (timeoutId) {
      window.clearTimeout(timeoutId);
    });
    enhanceRetryTimers = [];
  }

  /* Run enhance ASAP. Old path waited click+300ms then +80ms, so the upload box
     painted alone for ~400ms before PD / confirm appeared. */
  function scheduleEnhance() {
    var form = document.querySelector(FORM_SELECTOR);
    var card = form && form.querySelector('.ciw-la-upload-rx-card');

    if (isUploadEnhancementComplete(form, card)) {
      clearEnhanceRetries();
      if (enhanceTimer) {
        window.clearTimeout(enhanceTimer);
        enhanceTimer = null;
      }
      return;
    }

    if (enhanceTimer) {
      window.clearTimeout(enhanceTimer);
      enhanceTimer = null;
    }

    enhanceUploadRxForm();

    clearEnhanceRetries();
    [16, 50, 100, 200, 400].forEach(function (delay) {
      enhanceRetryTimers.push(
        window.setTimeout(function () {
          var currentForm = document.querySelector(FORM_SELECTOR);
          var currentCard = currentForm && currentForm.querySelector('.ciw-la-upload-rx-card');
          if (isUploadEnhancementComplete(currentForm, currentCard)) {
            return;
          }
          enhanceUploadRxForm();
        }, delay)
      );
    });
  }

  function setUploadStepActive(active) {
    var isActive = !!active;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    document.body.classList.toggle('ciw-la-upload-step-active', isActive);
    if (modal) {
      modal.classList.toggle('ciw-la-upload-step-active', isActive);
    }
  }

  function clearUploadStepContentBodyClasses() {
    var contentBody = document.querySelector('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-upload-rx-step--mobile');
    }
  }

  function teardownUploadStepDesktop() {
    if (MQ_MOBILE.matches) return;

    var form = document.querySelector(FORM_SELECTOR);
    setUploadStepActive(false);
    if (form) {
      resetUploadEnhancement(form);
      resetUploadDesktopLayout(form);
      var fieldsWrapper = form.querySelector('.la-fields-wrapper');
      if (fieldsWrapper) {
        fieldsWrapper.style.removeProperty('visibility');
      }
      var uploadWrapper = form.querySelector('.la-upload-wrapper');
      if (uploadWrapper) {
        uploadWrapper.style.removeProperty('display');
        uploadWrapper.style.removeProperty('visibility');
        uploadWrapper.style.removeProperty('opacity');
      }
      var pdContainer = form.querySelector('.la-pd-container');
      if (pdContainer) {
        pdContainer.style.removeProperty('display');
        pdContainer.style.removeProperty('visibility');
        pdContainer.style.removeProperty('opacity');
      }
    } else {
      clearUploadStepContentBodyClasses();
    }
    document.documentElement.style.setProperty('--ciw-la-footer-h', '0px');
  }

  function teardownUploadStepOnNavigateBack() {
    if (!MQ_MOBILE.matches) {
      teardownUploadStepDesktop();
      return;
    }

    setUploadStepActive(false);
    var form = document.querySelector(FORM_SELECTOR);
    clearUploadStepMark(form);
    resetUploadEnhancement(form);
    document.documentElement.style.setProperty('--ciw-la-footer-h', '0px');
  }

  function syncUploadStepActiveState() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    var uploadFlagged =
      document.body.classList.contains('ciw-la-upload-step-active') ||
      (modal && modal.classList.contains('ciw-la-upload-step-active'));
    if (!uploadFlagged) {
      return;
    }

    var chooseStep = document.querySelector('.la-choose-prescription-wrapper');
    var form = document.querySelector(FORM_SELECTOR);
    var onUpload =
      form &&
      form.classList.contains('ciw-la-upload-rx-form--mobile') &&
      form.querySelector('.ciw-la-upload-rx-card') &&
      !chooseStep;

    if (onUpload) {
      return;
    }

    setUploadStepActive(false);
    clearUploadStepContentBodyClasses();
    stopUploadDesktopWatch();
    stopUploadPdObserver();
    stopUploadExtractObserver();
    if (form) {
      resetUploadDesktopLayout(form);
    }
  }

  function bind() {
    if (!isEyeglassHost()) {
      return;
    }

    patchLensAdvizorUploadPd();
    var patchTimer = window.setInterval(function () {
      if (patchLensAdvizorUploadPd()) {
        window.clearInterval(patchTimer);
      }
    }, 250);

    document.addEventListener(
      'LensAdvizor:render:uploadForm',
      function () {
        patchLensAdvizorUploadPd();
        requireUploadPdEnabled(window.LensAdvizor);
        scheduleEnhance();
      },
      true
    );
    document.addEventListener('LensAdvizor:selectLensModal:open', function () {
      patchLensAdvizorUploadPd();
      primeUploadPdConfig();
      scheduleEnhance();
      scheduleRenameUploadSubmissionCard();
    });
    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      clearEnhanceRetries();
      stopUploadDesktopWatch();
      stopUploadPdObserver();
      stopUploadExtractObserver();
      if (enhanceTimer) {
        window.clearTimeout(enhanceTimer);
        enhanceTimer = null;
      }
      var api = shared();
      if (api && api.stopManualFooterWatch) {
        api.stopManualFooterWatch();
      }
      if (!MQ_MOBILE.matches) {
        teardownUploadStepDesktop();
      }
    });
    document.addEventListener('LensAdvizor:component:DidMount', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.method === 'renderUploadForm') {
        scheduleEnhance();
      }
    });
    document.addEventListener('LensAdvizor:render:manualEntryForm', function () {
      resetUploadEnhancement();
    });
    document.addEventListener('LensAdvizor:render:submissionMethods', function () {
      teardownUploadStepOnNavigateBack();
      scheduleRenameUploadSubmissionCard();
    });

    [
      'LensAdvizor:lens:rendered',
      'LensAdvizor:lensOptions:rendered',
      'LensAdvizor:addOns:rendered',
      'LensAdvizor:review:rendered',
      'LensAdvizor:prescriptionTypes:rendered'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, syncUploadStepActiveState);
    });

    document.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest(
            '#submission-type-0, .la-submission-type-0, [data-submission-type="upload"], [data-submission-type="uploaded"], .la-submission-type-upload, .la-submission-type-uploaded'
          )
        ) {
          requireUploadPdEnabled(window.LensAdvizor);
          scheduleEnhance();
          window.setTimeout(scheduleEnhance, 50);
          window.setTimeout(scheduleEnhance, 150);
        }

        if (
          event.target.closest(
            '.la-canEnterPrescriptionManually, #submission-type-1, .la-submission-type-1, .la-submission-type-manual, [data-submission-type="manual"], .la-manual-entry, .la-manual-prescription-entry'
          )
        ) {
          resetUploadEnhancement();
        }
      },
      true
    );

    if (typeof MQ_MOBILE.addEventListener === 'function') {
      MQ_MOBILE.addEventListener('change', scheduleEnhance);
    } else if (typeof MQ_MOBILE.addListener === 'function') {
      MQ_MOBILE.addListener(scheduleEnhance);
    }

    window.addEventListener('resize', function () {
      var form = document.querySelector(FORM_SELECTOR);
      if (form && form.classList.contains('ciw-la-upload-rx-form--mobile')) {
        applyUploadDesktopLayout(form);
      }
    });
  }

  window.ciwLaUploadRxApi = {
    reset: resetUploadEnhancement,
    enhance: enhanceUploadRxForm,
    uploadCardHasVisiblePd: uploadCardHasVisiblePd
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
